var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer d-flex p-2 px-3 bg-white border-top"},[_c('div',{class:[_vm.contained ? 'container' : 'container-fluid']},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('span',{staticClass:"copyright ml-auto my-auto mr-2"},[_vm._v(_vm._s(_vm.copyright))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281f42f3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MainFooter/MainFooter.vue
// module id = null
// module chunks = 